import { render, staticRenderFns } from "./paiement.vue?vue&type=template&id=92d3d752&scoped=true&"
import script from "./paiement.vue?vue&type=script&lang=js&"
export * from "./paiement.vue?vue&type=script&lang=js&"
import style0 from "./paiement.vue?vue&type=style&index=0&id=92d3d752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d3d752",
  null
  
)

export default component.exports